module.exports = __webpack_public_path__ + "img/019cf8c.png";